export const SECTION = 'section';
export const TASK = 'task';
export const SUBTASK = 'subtask';
export const NESTED_SUBTASK = 'nested subtask';
export const GROUP = 'group';
export const ITEM = 'item';
export const SUBITEM = 'subitem';
export const LIST = 'list';
export const AsanaHierarchyTypes = [SECTION, TASK, SUBTASK, NESTED_SUBTASK];
export const MondayHierarchyTypes = [GROUP, ITEM, SUBITEM];
export const ClickupHierarchyTypes = [LIST, TASK, SUBTASK, NESTED_SUBTASK];
